<template>
    <div id="up_pass_page">
        <div class="box">
            <div class="box-title">修改密码</div>
            <div class="forced-tip" v-if="isFirstLogin">
                您是首次登录，为了账号安全，请修改密码后继续使用
            </div>
            <div class="item">
                <div class="text">旧密码：</div>
                <input type="password" v-model="oldPassword" placeholder="请输入旧密码">
            </div>
            <div class="item item-new">
                <div class="text">新密码：</div>
                <input type="password" :class="{'pass-error':newPasswordBlur && newPassword.length<6}" v-model="newPassword" placeholder="请输入新密码（不少于6位）" @blur="newPasswordBlur=true">
                <div class="pass-tip" v-if="newPasswordBlur && newPassword.length<6">新密码不能少于6位</div>
            </div>
            <div class="item item-confirm">
                <div class="text">确认密码：</div>
                <input type="password" :class="{'pass-error':confirmPassword && newPassword!==confirmPassword}" v-model="confirmPassword" placeholder="请再次输入新密码">
                <div class="pass-tip" v-if="confirmPassword && newPassword!==confirmPassword">两次输入的密码不一致</div>
            </div>
             <div class="item" :class="{'btn-center':isFirstLogin}">
                <a href="javascript:void(0)" class="close" v-if="!isFirstLogin" @click="closepage()">取消</a>
                <a href="javascript:void(0)" class="submit" @click="handleUpdatePass()">确认</a>
            </div>
        </div>
    </div>

</template>


<script>
    import { ElMessage } from 'element-plus';
    import { updateUserInfo } from '@/tools/Api';
    export default {
        name:"updatepassword",
        props:{
            isFirstLogin:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return{
                oldPassword:"",
                newPassword:"",
                confirmPassword:"",
                newPasswordBlur:false
            }
        },
        methods:{
            closepage(){
                if(this.isFirstLogin){
                    return
                }
                this.$emit("close");
            },
            handleUpdatePass(){
                if(!this.oldPassword){
                    ElMessage({message:'请输入旧密码',type:'error',duration:1500})
                    return
                }
                if(!this.newPassword){
                    ElMessage({message:'请输入新密码',type:'error',duration:1500})
                    return
                }
                if(this.newPassword.length<6){
                    ElMessage({message:'新密码不能少于6位',type:'error',duration:1500})
                    return
                }
                if(this.newPassword!==this.confirmPassword){
                    // ElMessage({message:'两次输入的密码不一致',type:'error',duration:1500})
                    return
                }
                const params={
                    oldPassword:this.oldPassword,
                    newPassword:this.newPassword
                }
                updateUserInfo(params).then(res=>{
                    if(res.status==0){
                        
                        if(this.isFirstLogin){
                            // 第一次登录，跳转到登录页
                            setTimeout(()=>{
                                ElMessage({message:'密码修改成功，请重新登录',type:'success',duration:2000})
                                this.$router.push({name:'login'})
                            },2500)
                        }else{
                            ElMessage({message:'密码修改成功',type:'success',duration:1500})
                            this.closepage()
                        }
                    }else{
                        ElMessage({message:res.msg||'密码修改失败',type:'error',duration:1500})
                    }
                }).catch(error=>{
                    console.log(error)
                    ElMessage({message:'请求失败',type:'error',duration:1500})
                })
            }
        }

    }

</script>
<style scoped>
  #up_pass_page{
    width: 100%;
    height: 100%;
    min-width: 1400px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }
  #up_pass_page .box{
    width: 500px;
    min-height: 420px;
    position: relative;
    left: 50%;
    top: 50%;
    margin-top: -230px;
    margin-left: -250px;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px;
  }
  #up_pass_page .box .box-title{
    width: 100%;
    height: 40px;
    float: left;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
  }
  #up_pass_page .box .forced-tip{
    width: 100%;
    float: left;
    text-align: center;
    font-size: 13px;
    color: #e57834;
    background-color: #fff7e6;
    border: 1px solid #ffd591;
    border-radius: 4px;
    padding: 8px 12px;
    margin-bottom: 15px;
    box-sizing: border-box;
  }
  #up_pass_page .box .item{
    width: 100%;
    height: 50px;
    float: left;
    margin-bottom: 10px;
  }
  #up_pass_page .box .item .text{
    width: 100px;
    height: 50px;
    float: left;
    color: #4a4a4a;
    text-align: right;
    line-height: 50px;
    font-size: 14px;
  }
  #up_pass_page .box .item input{
    width: 300px;
    height: 40px;
    float: left;
    outline: none;
    margin-top: 5px;
    border:1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
    color: #4a4a4a;
    padding: 0 5px;
  }
  #up_pass_page .box .item input.pass-error{
    border-color: #f56c6c;
  }
  #up_pass_page .box .item.item-confirm{
    height: 70px;
  }
  #up_pass_page .box .item.item-new{
    height: 70px;
  }
  #up_pass_page .box .item .pass-tip{
    width: 300px;
    height: 20px;
    float: left;
    margin-left: 110px;
    color: #f56c6c;
    font-size: 12px;
    line-height: 20px;
  }
  #up_pass_page .box .item a{
    width: 80px;
    height: 40px;
    float: left;
    margin-top: 5px;
    background-color: #fb3a05;
    color: #fff;
    font-size: 14px;
    border-radius: 5px;
    line-height: 40px;
    text-decoration: none;
    text-align: center;
  }
#up_pass_page .box .item a.close{
    margin-left: 130px;
    margin-right: 10px;
}
#up_pass_page .box .item a.submit{
    background-color: #09b228;
}
#up_pass_page .box .item.btn-center{
    text-align: center;
}
#up_pass_page .box .item.btn-center a{
    float: none;
    display: inline-block;
    margin-left: 0;
}

</style>